/** Annotation on System entities holding the supplyadmin appcode (e.g. LOG004). */
export const ANNOTATION_SYSTEM_APPCODE = 'supplyadmin.totvs.app/appcode';
